import { render, staticRenderFns } from "./BasicRaceInfo.vue?vue&type=template&id=d9d8fb20&scoped=true&"
import script from "./BasicRaceInfo.vue?vue&type=script&lang=js&"
export * from "./BasicRaceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d8fb20",
  null
  
)

export default component.exports